<template>
    <div>
        <v-card class="dashboard-widget p-3" color="#ffffff">
            <v-card-title :style="'color:' + color" class="justify-start display-1 pt-0">
                <slot name="card-title"></slot>
                <slot v-if="icon" name="card-icon">
                    <img :src="icon" alt="" class="card-icon" />
                </slot>
            </v-card-title>
            <v-card-text class="text-left title text-uppercase body-1" style="color: #cbd4e0">
                <slot name="card-text"></slot>
            </v-card-text>
            <div class="pr-4 pl-4">
                <slot name="footer">
                    <v-progress-linear :color="progressColor" :value="progressValue" title="Change"></v-progress-linear>
                    <v-row class="d-flex justify-content-between">
                        <v-col class="text-left change-title" cols="6">Change</v-col>
                        <v-col :style="'color:' + color" class="text-right change-percents" cols="6">
                            {{ changePercentText }}
                        </v-col>
                    </v-row>
                </slot>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        newValue: {
            type: Number,
            required: true,
        },
        oldValue: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: false,
            default: '#000',
        },
    },
    computed: {
        progressColor() {
            return this.color;
        },
        progressValue() {
            return (this.newValue / this.oldValue) * 100;
        },
        changePercentText() {
            let percents = _.round((this.newValue / this.oldValue) * 100, 2);
            if (percents === Infinity) {
                return '100%';
            }
            if (isNaN(percents)) {
                return '';
            }
            if (percents > 100) {
                return _.round(percents - 100, 2) + '%';
            }
            return _.round(100 - percents, 2) + '%';
        },
    },
};
</script>

<style scoped>
.title {
    color: #b9b8be;
    font-weight: 500;
}

.card-icon {
    position: absolute;
    width: 30px;
    filter: invert(1);
    opacity: 0.2;
    top: 20px;
    right: 30px;
}

.change-title {
    color: rgb(203, 212, 224);
    font-weight: 400;
}

.change-percents {
    font-weight: 400;
}
</style>
